export const table_Style = {
  emptystate: {
    color: '#888888',
    fontSize: '16px',
    fontWeight: 500,
    textAlign: 'center',
    mt: 2,
  },
};
